



















import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../base/components/system/mixins";
import { PointEditor} from "../../../../../../base/components/drawing";
import { VectorCoordinateEditableMixin } from "../objects/mixins";

@Component({
  components: {
    PointEditor,
    VectorCoordinateEditableMixin
  },
})
export default class VectorCoordinateEditor extends Mixins(ModelEditableMixin, VectorCoordinateEditableMixin) {
}
